export type LoaderWithInterestingFactsAboutAITranslations = {
  content: {
    leadingText: string;
    loaderDynamicInfo: {
      [key: string]: string;
    };
  };
};

export const loaderWithInterestingFactsAboutAITranslations: LoaderWithInterestingFactsAboutAITranslations =
  {
    content: {
      leadingText: 'AI works to deliver you the best results!',
      loaderDynamicInfo: {
        text1:
          'Did you know that the first attempts to create artificial intelligence took place in the 1950s?',
        text10:
          'Did you know that AI can generate culinary recipes based on the ingredients you input into the system?',
        text11:
          'Did you know that AI can already recognize plant species based on images taken by users?',
        text12:
          'Did you know that AI analyzes data from telescopes to help astronomers discover new planets?',
        text13:
          'Did you know that AI supports editorial work in book publishing by suggesting corrections and improvements in manuscripts?',
        text14:
          'Did you know that AI assists in composing film music by analyzing scripts and emotions depicted in scenes?',
        text15:
          'Did you know that AI is used to optimize poker playing strategies by learning from the best players?',
        text16:
          "Did you know that AI supports interior design by analyzing users' aesthetic preferences and proposing individually tailored solutions?",
        text17: 'Did you know that AI can generate virtual clothing designs?',
        text18:
          'Did you know that AI can analyze your reading habits to recommend books that you are most likely to enjoy?',
        text19:
          'Did you know that there is AI capable of simulating ancient battles by analyzing historical data and strategies?',
        text2:
          'Did you know that there are AI algorithms that can forecast the weather more accurately than traditional methods?',
        text20:
          'Did you know that AI can already compose musical pieces in the styles of historical composers like Mozart or Beethoven?',
        text21:
          'Did you know that artificial intelligence is used to create realistic simulations of ecosystems, helping scientists understand the effects of climate change?',
        text22:
          'Did you know that AI can identify and classify different bird species based on their songs, assisting researchers in monitoring wildlife populations?',
        text3:
          'Did you know that in Japan, AI was used to write a novel that came close to winning a literary competition?',
        text4:
          'Did you know that artificial intelligence helps archaeologists discover previously unknown historical locations through the analysis of satellite images?',
        text5:
          'Did you know that AI can independently learn to play chess and defeat world-class champions?',
        text6:
          'Did you know that AI helps train athletes by analyzing their techniques and suggesting optimizations in their movements?',
        text7:
          'Did you know that AI can learn a foreign language by analyzing texts in that language alone?',
        text8:
          'Did you know that there is AI capable of analyzing medical images and detecting diseases with the same effectiveness as doctors?',
        text9:
          'Did you know that artificial intelligence can simulate conversations with historical figures using only records of their speeches?',
      },
    },
  };
